var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "q-mt-xl text-center q-pb-md text-faded copyright-drawer" },
    [
      _c("small", [
        _vm._v(
          "Copyright © " +
            _vm._s(new Date().getFullYear()) +
            ": " +
            _vm._s(_vm.getProjectName) +
            " v" +
            _vm._s(_vm.getVersion) +
            " - Powered by "
        ),
        _c("a", { attrs: { href: "https://take5.com.br" } }, [
          _vm._v("Take 5 LMS")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }